const sortArrayByProperty = (property, array = []) => [...array].sort((a, b) => {
    if (a?.[property]?.localeCompare && b?.[property]) {
        return a[property].localeCompare(b[property]);
    }
    return 0;
});

export default sortArrayByProperty;
